module.exports = __webpack_public_path__ + "img/emiarch-1-sel.9f7114b9.svg";